import React from "react";
import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import { getTheme } from "@icarius-pages/login/selectors";
import { getAppColor } from "@icarius-app/selectors";
import { hexToRgb } from "@icarius-utils/colors";
import { HOVER_OPACITY, HOVER_OPACITY_LIGHT } from "@icarius-utils/constants";

const useStyles = makeStyles({
    root: (props) => ({
        backgroundColor: props.customColor
            ? props.customColor
            : props.isAccept
            ? "var(--buttonAccept)"
            : "var(--buttonCancel)",
        border: props.isAccept || props.customColor ? "1px solid transparent" : "1px solid var(--borderColor)",
        borderRadius: "6px",
        boxShadow: props.isAccept || props.customColor ? "0px 2px 4px rgba(0, 0, 0, 0.25)" : null,
        opacity: props.disabled ? 0.5 : 1,
        "&:hover": {
            backgroundColor:
                hexToRgb(props.color, props.theme === "dark" ? HOVER_OPACITY : HOVER_OPACITY_LIGHT) + "!important",
        },
    }),
});

const ButtonDialogAction = (props) => {
    const { fullWidth, text, onClick, isAccept, type, disabled, startIcon, customColor } = props;

    const { theme } = useSelector(getTheme);
    const color = useSelector(getAppColor);
    const classes = useStyles({ isAccept, theme, color, customColor, disabled });

    return (
        <Button
            onClick={onClick}
            fullWidth={fullWidth}
            classes={{
                root: classes.root,
            }}
            disabled={disabled}
            type={type}
            startIcon={startIcon}
            className="whiteText"
            variant={"outlined"}
            disableRipple={true}
        >
            {text}
        </Button>
    );
};

export default ButtonDialogAction;
